import * as React from "react";
import { AnchoredPanelProps } from "./AnchoredPanelTypes";
import { InternalAnchoredPanel } from "./InternalAnchoredPanel";

export type LandingPagePanelProps = Pick<AnchoredPanelProps, "children" | "testId">;

export const LandingPagePanel = (props: LandingPagePanelProps): JSX.Element => (
  <InternalAnchoredPanel {...props} title="" isOpen hideCloseButton preventCloseOnEsc />
);
